import type { ObjectShape } from "yup";

import {
  getBulkBasePriceAdditionToggleFieldName,
  ICustomField,
  yupLocalized,
} from "@ryde/shared";

const MIN_PERCENTAGE_OF_INCREASE = -100;
const MAX_PERCENTAGE_OF_INCREASE = 100;

export enum updateBasePriceDrawerForm {
  percentageOfIncrease = "percentageOfIncrease",
  roundFinalPrice = "roundFinalPrice",
}

/** Core fields only — dynamic `includeAdditionIncrease_*` toggles exist at runtime (see default builder). */
export interface IUpdateBasePriceForm {
  [updateBasePriceDrawerForm.percentageOfIncrease]: number;
  [updateBasePriceDrawerForm.roundFinalPrice]: boolean;
}

export const buildUpdateBasePriceValidationSchema = (
  additionControls: ICustomField[],
): ObjectShape => {
  const additionToggleFields = additionControls.reduce<ObjectShape>(
    (acc, control) => {
      acc[getBulkBasePriceAdditionToggleFieldName(control.name)] =
        yupLocalized.boolean();
      return acc;
    },
    {} as ObjectShape,
  );

  return {
    [updateBasePriceDrawerForm.percentageOfIncrease]: yupLocalized
      .number()
      .required()
      .min(MIN_PERCENTAGE_OF_INCREASE)
      .max(MAX_PERCENTAGE_OF_INCREASE),
    [updateBasePriceDrawerForm.roundFinalPrice]: yupLocalized.boolean(),
    ...additionToggleFields,
  };
};

export const buildUpdateBasePriceDefaultValues = (
  additionControls: ICustomField[],
): Record<string, boolean | number> => {
  const additionToggles = additionControls.reduce(
    (acc, control) => {
      acc[getBulkBasePriceAdditionToggleFieldName(control.name)] = false;
      return acc;
    },
    {} as Record<string, boolean>,
  );

  return {
    [updateBasePriceDrawerForm.percentageOfIncrease]: 0,
    [updateBasePriceDrawerForm.roundFinalPrice]: false,
    ...additionToggles,
  };
};
